import { render, staticRenderFns } from "./MonthExpenses.vue?vue&type=template&id=28364914&scoped=true"
import script from "./MonthExpenses.vue?vue&type=script&lang=js"
export * from "./MonthExpenses.vue?vue&type=script&lang=js"
import style0 from "./MonthExpenses.vue?vue&type=style&index=0&id=28364914&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28364914",
  null
  
)

export default component.exports